<div class="region-management">
  <app-orphan-municipality
    *ngIf="orphanMunicipalities?.length"
    [municipalities]="orphanMunicipalities"
    (refresh)="loadData(selectedParentRegion).subscribe()"
  ></app-orphan-municipality>

  <div class="main-section">
    <div class="top-section">
      <div class="parent-region-selection">
        <app-dropdown class="dropdown" [value]="selectedParentRegion.name">
          <app-dropdown-option
            class="dropdown-option"
            *ngFor="let option of parentRegionTypes; trackBy: trackByFn"
            [value]="option"
            (optionSelect)="selectDropdownParentRegion(option)"
          >
            {{ option.name }}
          </app-dropdown-option>
        </app-dropdown>
      </div>
    </div>
    <mat-card class="region-list-section card">
      <div class="header-section">
        <div class="region-name-column">{{ 'module.userProfile.regionalAdmin.regionLevelHeaderText' | translate }}</div>
        <div class="edit-column" [style.visibility]="selectedParentRegion.code !== 'POHOLR' ? 'visible' : 'hidden'">
          {{ 'module.userProfile.regionalAdmin.editNameHeaderText' | translate }}
        </div>
        <div class="delete-column">{{ 'module.userProfile.regionalAdmin.deleteHeaderText' | translate }}</div>
        <div class="primary-kam-column">{{ 'module.userProfile.regionalAdmin.kamContactHeaderText' | translate }}</div>
        <div class="re-assign-column">{{ 'module.userProfile.regionalAdmin.reassignHeaderText' | translate }}</div>
      </div>
      <div class="region-list">
        <app-list-tree
          #tree
          [itemSize]="20"
          [searchPlaceholder]="'Freitextsuche'"
          [data]="regionSelections"
          [multiple]="true"
          [templateRef]="regionManagement"
          (completeEvent)="treeViewDataBinded()"
          (selectEvent)="treeSelect($event)"
          (searchResetEvent)="tree.toggleNodeExpansionByLevel(0)"
        ></app-list-tree>
      </div>

      <div class="action-section" *ngIf="isElementVisible">
        <button class="btn btn-outline-primary move-to-button" (click)="move()" [disabled]="!hasSelections">
          <span class="fa fa-share"></span>{{ 'module.userProfile.regionalAdmin.moveToButtonText' | translate }}
        </button>
      </div>
    </mat-card>
  </div>
  <ng-template #regionManagement let-node="node">
    <span class="add-icon" [style.margin-left]="marginAdjustment + 80 + 'px'">
      <span class="fa fa-plus" *ngIf="node.item.data.isAdd" (click)="addChildren(node.item)"></span>
    </span>
    <span class="edit-icon">
      <span class="fa fa-pencil" *ngIf="node.item.data.isEdit" (click)="editNode(node.item)"></span>
    </span>
    <span class="delete-icon">
      <span class="fa fa-trash" *ngIf="node.item.data.isDelete" (click)="deleteNode(node.item)"></span>
    </span>
    <span class="primary-kam-text" *ngIf="node.item.data && node.item.data.primaryKam">
      {{ node.item.data.primaryKam.firstName }}&nbsp;{{ node.item.data.primaryKam.lastName }}
    </span>
    <span class="primary-kam-reassign">
      <span class="fa fa-pencil-square-o" *ngIf="node.item.data && node.item.data.primaryKam" (click)="reAssignKAM(node.item)"></span>
    </span>
  </ng-template>
</div>
